import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import OptionsNode from '../../shared/OptionsNode';
import NodeWrapper from '../../shared/NodeWrapper';

function DropdownTextfieldNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <OptionsNode data={data} icon={ICONIFY.DROPDOWN_TEXT_FIELD} />
        </NodeWrapper>
    );
}

export default React.memo(DropdownTextfieldNode)
